// Build405: shared editor copy; no design content or persisted keys are translated.
(() => {
  'use strict';
  if (window.SmoofI18n) return;
  const italian = {
  "Save": "Salva",
  "File name": "Nome del file",
  "The .smoofdesign extension is added automatically.": "L’estensione .smoofdesign viene aggiunta automaticamente.",
  "Please enter a file name.": "Inserisca un nome per il file.",
  "Drop one .smoofdesign file here": "Trascini qui un file .smoofdesign",
  "Please drop exactly one .smoofdesign file.": "Trascini un solo file .smoofdesign.",

  "QR code": "Codice QR",
  "The image could not be read.": "Impossibile leggere l’immagine.",
  "Crop logo": "Ritaglia logo",
  "Drag the frame or adjust the edges. Your original is preserved.": "Trascini il riquadro o regoli i bordi. L’originale viene conservato.",
  "Close": "Chiudi",
  "Original with selected crop": "Originale con ritaglio selezionato",
  "Trim transparent edges": "Rimuovi bordi trasparenti",
  "Full original": "Originale completo",
  "Inset from image edges in pixels": "Distanza dai bordi dell’immagine in pixel",
  "Loading image …": "Caricamento immagine …",
  "Cancel": "Annulla",
  "Apply crop": "Applica ritaglio",
  "This image is too large to crop. Please use a version up to 16 megapixels.": "L’immagine è troppo grande per il ritaglio. Utilizzi una versione fino a 16 megapixel.",
  "Fits the existing logo area. Linked duplicates follow.": "Si adatta all’area del logo esistente. I duplicati collegati vengono aggiornati.",
  "The image is fully transparent. Please choose a crop manually.": "L’immagine è completamente trasparente. Selezioni il ritaglio manualmente.",
  "No transparent outer edges found. You can adjust the frame manually.": "Nessun bordo esterno trasparente trovato. Può regolare il riquadro manualmente.",
  "Could not detect the edges. Please adjust the frame manually.": "Impossibile rilevare i bordi. Regoli il riquadro manualmente.",
  "Could not create crop.": "Impossibile creare il ritaglio.",
  "Your workspace": "La Sua area di lavoro",
  "Select an element on the print area to move it or open its settings. On mobile, tap it. Font selection and logo cropping open within the same panel; use the back arrow to return to its settings.": "Selezioni un elemento nell’area di stampa per spostarlo o aprirne le impostazioni. Sul cellulare, lo tocchi. La scelta del carattere e il ritaglio del logo si aprono nello stesso pannello; la freccia indietro riporta alle impostazioni.",
  "Start with templates": "Inizi dai modelli",
  "Choose an available language, then a category and a design. Available templates depend on your product and shop area. You will be asked to confirm before your design is replaced.": "Scelga una lingua disponibile, poi una categoria e un design. I modelli disponibili dipendono dal prodotto e dall’area del negozio. Prima di sostituire il design Le verrà chiesta conferma.",
  "Text and fonts": "Testo e caratteri",
  "Select characters or words within a text field to change their font, available font style and colour. “Whole text” clears the selection. Size, letter spacing and rotation still apply to the whole field.": "Selezioni caratteri o parole in un campo di testo per modificarne il carattere, lo stile disponibile e il colore. «Testo intero» annulla la selezione. Dimensione, spaziatura e rotazione si applicano sempre all’intero campo.",
  "Your font library": "La Sua libreria di caratteri",
  "The highlighted font control opens your library of standard fonts and your previously uploaded fonts. Use “Upload custom font” to add several WOFF, WOFF2, TTF or OTF files together and confirm that you hold the required usage and production rights.": "Il controllo evidenziato apre la libreria dei caratteri standard e di quelli già caricati. Con «Carica carattere personalizzato» può aggiungere più file WOFF, WOFF2, TTF o OTF insieme, confermando di possedere i diritti d’uso e di produzione necessari.",
  "Logos and cropping": "Loghi e ritaglio",
  "Upload your main logo here. The crop tool appears once a suitable image is uploaded. For PNG, JPG and WEBP in colour printing, adjust the crop or remove transparent outer margins. Restore the full original at any time. Cropping is unavailable for SVG and laser engraving.": "Carichi qui il logo principale. Lo strumento di ritaglio compare dopo il caricamento di un’immagine adatta. Per PNG, JPG e WEBP nella stampa a colori, regoli il ritaglio o rimuova i margini esterni trasparenti. Può ripristinare l’originale completo in qualsiasi momento. Il ritaglio non è disponibile per SVG e incisione laser.",
  "Keep every element in view": "Tutti gli elementi sotto controllo",
  "Use Layers to select, edit, hide and restore elements. You can enter percentage values directly or make small adjustments with the plus and minus controls.": "Utilizzi Livelli per selezionare, modificare, nascondere e ripristinare gli elementi. Può inserire direttamente i valori percentuali o regolarli con i pulsanti più e meno.",
  "Add elements": "Aggiunga elementi",
  "Use Add for available text, logos, pictograms, payment providers and social elements, including rating stars and brand variants in original colours. DOT ME laser artwork stays black; other options depend on your product and design.": "Con Aggiungi può inserire testi, loghi, pittogrammi, metodi di pagamento ed elementi social disponibili, incluse stelle di valutazione e varianti dei marchi nei colori originali. Nell’incisione laser di DOT ME i motivi restano neri; le altre opzioni dipendono dal prodotto e dal design.",
  "Align precisely": "Allineamento preciso",
  "The ruler menu controls measurements and horizontal and vertical snapping separately. Move selected elements with the arrow keys; hold Shift for larger steps. While typing, the keys continue to control the text.": "Il menu del righello controlla separatamente le misure e l’aggancio orizzontale e verticale. Sposti gli elementi selezionati con i tasti freccia; tenga premuto Maiusc per spostamenti maggiori. Durante la digitazione i tasti continuano a controllare il testo.",
  "Designs and files": "Design e file",
  "Save your design as a .smoofdesign file and reopen it later. For double-sided products, the file includes both sides. This panel also offers a product preview and proof and production downloads. When loading on another product, that product’s technical capabilities apply.": "Salvi il design come file .smoofdesign per riaprirlo in seguito. Nei prodotti fronte-retro il file include entrambi i lati. Questo pannello offre anche l’anteprima del prodotto e il download dei file di approvazione e produzione. Caricando il design su un altro prodotto, si applicano le caratteristiche tecniche di quest’ultimo.",
  "Edit with confidence": "Modifichi in sicurezza",
  "Use Undo and Redo to manage changes. Reset always opens a choice first. Choose strong contrast for custom QR colours; see the QR panel for scanning guidance.": "Utilizzi Annulla e Ripristina per gestire le modifiche. Reimposta apre sempre prima una scelta. Per i colori personalizzati del QR scelga un contrasto elevato; nel pannello QR trova le indicazioni sulla scansione.",
  "Front and back": "Fronte e retro",
  "Front and back have independent designs. “Copy front to back” transfers your front design to the back. Double-sided design files and templates can replace both sides together.": "Fronte e retro hanno design indipendenti. «Copia fronte sul retro» trasferisce il design anteriore sul retro. I file e i modelli fronte-retro possono sostituire entrambi i lati insieme.",
  "Front and 3D view": "Vista frontale e 3D",
  "The 3D view shows how the design looks on the product without changing the design or its print position. Return to the front view to edit details.": "La vista 3D mostra l’effetto del design sul prodotto senza modificarlo né cambiarne la posizione di stampa. Torni alla vista frontale per modificare i dettagli.",
  "Help stays available": "Aiuto sempre disponibile",
  "Open “?” to read about the main features, check print-area guidance or restart this introduction at any time.": "Apra «?» per consultare le funzioni principali, leggere le indicazioni sull’area di stampa o riavviare questa introduzione in qualsiasi momento.",
  "Close introduction": "Chiudi introduzione",
  "SMOOF DOTS": "SMOOF DOTS",
  "Back": "Indietro",
  "End tour": "Termina guida",
  "Welcome to the SMOOF DOTS Design Editor": "Benvenuti nell’editor di design SMOOF DOTS",
  "This short introduction shows you the most important areas without changing your design.": "Questa breve introduzione mostra le aree principali senza modificare il Suo design.",
  "Takes about 1 minute": "Richiede circa 1 minuto",
  "Later": "Più tardi",
  "Start introduction": "Avvia introduzione",
  "Explore the editor": "Esplora l’editor",
  "Next": "Avanti",
  "Automatic rotation": "Rotazione automatica",
  "Off": "Disattivata",
  "Open a 360° view of your design": "Apri una vista a 360° del design",
  "360° view · RHL": "Vista a 360° · RHL",
  "Back to editor": "Torna all’editor",
  "Try again": "Riprova",
  "360° view · RHL ": "Vista a 360° · RHL ",
  "Preparing your design for the 360° view …": "Preparazione del design per la vista a 360° …",
  "Interactive 360° product view": "Vista interattiva del prodotto a 360°",
  "The 360° view could not be loaded. Your design is preserved.": "Impossibile caricare la vista a 360°. Il design viene conservato.",
  "360° view · QHS": "Vista a 360° · QHS",
  "360° view · QHS ": "Vista a 360° · QHS ",
  "360° view · RHS": "Vista a 360° · RHS",
  "360° view · RHS ": "Vista a 360° · RHS ",
  "360° view · RML": "Vista a 360° · RML",
  "360° view · RML ": "Vista a 360° · RML ",
  "360° view · QHL": "Vista a 360° · QHL",
  "360° view · QHL ": "Vista a 360° · QHL ",
  "Product view": "Vista del prodotto",
  "View DOT GL with epoxy dome and 3M adhesive backing from all sides": "Visualizza DOT GL da ogni lato, con cupola in resina epossidica e retro adesivo 3M",
  "360° view · DOT GL": "Vista a 360° · DOT GL",
  "View stainless steel DOT ME with 3M adhesive backing from all sides": "Visualizza DOT ME in acciaio inox da ogni lato, con retro adesivo 3M",
  "360° view · DOT ME": "Vista a 360° · DOT ME",
  "View matte DOT MA with 3M adhesive backing from all sides": "Visualizza DOT MA opaco da ogni lato, con retro adesivo 3M",
  "360° view · DOT MA": "Vista a 360° · DOT MA",
  "This font does not contain all characters. Please choose a compatible font.": "Questo carattere non contiene tutti i simboli necessari. Scelga un carattere compatibile.",
  "Please use a single line for curved text.": "Per il testo curvo utilizzi una sola riga.",
  "Please shorten curved text to at most 500 characters.": "Riduca il testo curvo a un massimo di 500 caratteri.",
  "Font preparation is loading. Please try again.": "Preparazione del carattere in caricamento. Riprovi.",
  "Check text shape": "Verifica forma del testo",
  "Loading font …": "Caricamento carattere …",
  "Curved text is still loading.": "Il testo curvo è ancora in caricamento.",
  "The text does not fit in the available area.": "Il testo non entra nell’area disponibile.",
  "The font could not be prepared.": "Impossibile preparare il carattere.",
  "Arcs and circles use a single line of text.": "Archi e cerchi utilizzano una sola riga di testo.",
  "Text shape": "Forma del testo",
  "Straight": "Dritto",
  "Arc": "Arco",
  "Circle": "Cerchio",
  "Edit text": "Modifica testo",
  "Bend strength": "Curvatura",
  "Downward": "Verso il basso",
  "Upward": "Verso l’alto",
  "Circle size": "Dimensione del cerchio",
  "Small": "Piccolo",
  "Large": "Grande",
  "Reverse reading direction": "Inverti direzione di lettura",
  "The pill outline follows the text as a band. The circle centre stays free.": "Il contorno a capsula segue il testo come una fascia. Il centro del cerchio resta libero.",
  "Circle size adjusted to fit the text.": "Dimensione del cerchio adattata al testo.",
  "Text and band stay within the print area.": "Testo e fascia restano nell’area di stampa.",
  "Find size, colour and font one level back.": "Dimensione, colore e carattere si trovano nel livello precedente.",
  "downward": "verso il basso",
  "upward": "verso l’alto",
  "between small and large": "tra piccolo e grande",
  "Reading direction: reversed": "Direzione di lettura: invertita",
  "Reading direction: normal": "Direzione di lettura: normale",
  "Please use a single text line for an arc or circle.": "Per un arco o un cerchio utilizzi una sola riga di testo.",
  "The font file has no readable data.": "Il file del carattere non contiene dati leggibili.",
  "The saved font data is invalid.": "I dati del carattere salvato non sono validi.",
  "The font file is empty or damaged.": "Il file del carattere è vuoto o danneggiato.",
  "The font file is larger than 3 MB.": "Il file del carattere supera 3 MB.",
  "Font collections are not supported in this test yet.": "Le raccolte di caratteri non sono ancora supportate in questo test.",
  "Please select a valid TTF or OTF file.": "Selezioni un file TTF o OTF valido.",
  "The font validator could not be loaded.": "Impossibile caricare il validatore dei caratteri.",
  "The font cannot be read for production.": "Il carattere non è leggibile per la produzione.",
  "The font contains no usable glyphs.": "Il carattere non contiene glifi utilizzabili.",
  "Variable fonts are not supported in this first test yet.": "I caratteri variabili non sono ancora supportati in questo primo test.",
  "The browser could not load the font.": "Il browser non ha potuto caricare il carattere.",
  "A saved font record is invalid.": "Un record di carattere salvato non è valido.",
  "A saved font checksum does not match.": "La somma di controllo di un carattere salvato non corrisponde.",
  "A saved font identifier does not match.": "L’identificativo di un carattere salvato non corrisponde.",
  "My fonts": "I miei caratteri",
  "✓ Selected": "✓ Selezionato",
  "Use font": "Usa carattere",
  "No matching custom font found.": "Nessun carattere personalizzato corrispondente trovato.",
  "Your custom fonts will appear here. Use “Upload” to add TTF and OTF files.": "I caratteri personalizzati appariranno qui. Utilizzi «Carica» per aggiungere file TTF e OTF.",
  "Please select a TTF or OTF file.": "Selezioni un file TTF o OTF.",
  "Uploaded fonts may total no more than 12 MB.": "I caratteri caricati non possono superare complessivamente 12 MB.",
  "Please select no more than 20 font files at once.": "Selezioni al massimo 20 file di caratteri alla volta.",
  "Already available": "Già disponibile",
  "Added": "Aggiunto",
  "The font could not be loaded.": "Impossibile caricare il carattere.",
  "Font source": "Origine del carattere",
  "Font library": "Libreria di caratteri",
  "＋ Upload": "＋ Carica",
  "Search my fonts": "Cerca nei miei caratteri",
  "I have the required usage and production rights.": "Possiedo i diritti d’uso e di produzione necessari.",
  "Please confirm the usage and production rights first.": "Confermi prima i diritti d’uso e di produzione.",
  "TTF / OTF · up to 20 files · 3 MB per file · 12 MB total": "TTF / OTF · fino a 20 file · 3 MB per file · 12 MB totali",
  "Choose files": "Scegli file",
  "The selected fonts are still being validated …": "La verifica dei caratteri selezionati è ancora in corso …",
  "Font style of the table or room number": "Stile del numero di tavolo o camera",
  "Colour of the table or room number": "Colore del numero di tavolo o camera",
  "+ Number": "+ Numero",
  "Add table or room number": "Aggiungi numero di tavolo o camera",
  "Hide table or room number": "Nascondi numero di tavolo o camera",
  "Colour of the small circle": "Colore del cerchio piccolo",
  "Reduce number size": "Riduci dimensione del numero",
  "Increase number size": "Aumenta dimensione del numero",
  "Reset number": "Reimposta numero",
  "Edit table or room number directly": "Modifica direttamente il numero di tavolo o camera",
  "Select the colour of the small circle": "Selezioni il colore del cerchio piccolo",
  "e.g. Table 56": "es. Tavolo 56",
  "Show table or room number": "Mostra numero di tavolo o camera",
  "For laser engraving, the colours in your design are converted to black.": "Per l’incisione laser, i colori del design vengono convertiti in nero.",
  "Images or pictograms unsuitable for laser engraving were omitted.": "Le immagini o i pittogrammi non adatti all’incisione laser sono stati omessi.",
  "The table number could not be fully loaded. Please reload the page and open the file again.": "Impossibile caricare completamente il numero di tavolo. Ricarichi la pagina e riapra il file.",
  "The saved extra pictograms are invalid.": "I pittogrammi aggiuntivi salvati non sono validi.",
  "The background image has not finished loading. Please wait briefly and save again.": "Il caricamento dell’immagine di sfondo non è terminato. Attenda un momento e salvi di nuovo.",
  "The background image could not be read.": "Impossibile leggere l’immagine di sfondo.",
  "The background file is not a supported image.": "Il file di sfondo non è un’immagine supportata.",
  "Extra pictograms are not loaded yet. Please wait briefly and try again.": "I pittogrammi aggiuntivi non sono ancora caricati. Attenda un momento e riprovi.",
  "The file is too large.": "Il file è troppo grande.",
  "Design file saved": "File del design salvato",
  "The design could not be saved.": "Impossibile salvare il design.",
  "Not a valid SMOOF design file.": "File di design SMOOF non valido.",
  "Text formatting is still loading. Please try again.": "La formattazione del testo è ancora in caricamento. Riprovi.",
  "Text shapes are still loading. Please try again.": "Le forme del testo sono ancora in caricamento. Riprovi.",
  "This file version is not supported.": "Questa versione del file non è supportata.",
  "Front and back designs are missing or invalid.": "I design del fronte e del retro sono mancanti o non validi.",
  "The design data is missing.": "Mancano i dati del design.",
  "The saved font name is invalid.": "Il nome del carattere salvato non è valido.",
  "The embedded font data is invalid.": "I dati del carattere incorporato non sono validi.",
  "The saved product settings are invalid.": "Le impostazioni del prodotto salvate non sono valide.",
  "The saved NFC setting is invalid.": "L’impostazione NFC salvata non è valida.",
  "The saved print size is invalid.": "La dimensione di stampa salvata non è valida.",
  "A saved product setting is invalid.": "Un’impostazione del prodotto salvata non è valida.",
  "An embedded font record is invalid.": "Un record di carattere incorporato non è valido.",
  "An embedded font contains invalid data.": "Un carattere incorporato contiene dati non validi.",
  "An embedded font is too large.": "Un carattere incorporato è troppo grande.",
  "The file belongs to an unsupported SMOOF product.": "Il file appartiene a un prodotto SMOOF non supportato.",
  "Product adaptation is not loaded yet. Please reload the page and try again.": "L’adattamento al prodotto non è ancora caricato. Ricarichi la pagina e riprovi.",
  "Extra pictograms could not be restored.": "Impossibile ripristinare i pittogrammi aggiuntivi.",
  "Custom-font support is not loaded yet. Please reload the page.": "Il supporto per i caratteri personalizzati non è ancora caricato. Ricarichi la pagina.",
  "The background image could not be restored.": "Impossibile ripristinare l’immagine di sfondo.",
  "Design opened; unavailable product settings were retained.": "Design aperto; le impostazioni del prodotto non disponibili sono rimaste invariate.",
  "Design adapted and opened successfully.": "Design adattato e aperto correttamente.",
  "Design opened successfully.": "Design aperto correttamente.",
  "Side management is not ready. Please reload the page.": "La gestione dei lati non è pronta. Ricarichi la pagina.",
  "A design file is already being processed.": "È già in corso l’elaborazione di un file di design.",
  "Processing design …": "Elaborazione del design …",
  "The file will replace both front and back. Continue?": "Il file sostituirà sia il fronte sia il retro. Continuare?",
  "Only the front of this double-sided file will be used. The current design will be replaced. Continue?": "Verrà utilizzato solo il fronte di questo file fronte-retro. Il design attuale verrà sostituito. Continuare?",
  "Design opened and adapted to this product’s technical requirements.": "Design aperto e adattato ai requisiti tecnici di questo prodotto.",
  "Front and back opened successfully.": "Fronte e retro aperti correttamente.",
  "Front design opened successfully.": "Design del fronte aperto correttamente.",
  "The file could not be opened.": "Impossibile aprire il file.",
  "Whole text": "Testo intero",
  "Select characters in the text to format them.": "Selezioni i caratteri nel testo per formattarli.",
  "Text selection": "Selezione del testo",
  "Mixed": "Misto",
  "Clear selection and format whole text": "Cancella selezione e formatta il testo intero",
  "Rotation": "Rotazione",
  "Rotate left": "Ruota a sinistra",
  "Rotate right": "Ruota a destra",
  "Text line 1": "Riga di testo 1",
  "Font, style, colour and size": "Carattere, stile, colore e dimensione",
  "Text line 2": "Riga di testo 2",
  "Text line 3": "Riga di testo 3",
  "Left pictogram": "Pittogramma sinistro",
  "Symbol, rotation, colours and label": "Simbolo, rotazione, colori ed etichetta",
  "Right pictogram": "Pittogramma destro",
  "Position, size, file and visibility": "Posizione, dimensione, file e visibilità",
  "Logo 1 duplicate": "Duplicato del logo 1",
  "Linked duplicate of logo 1": "Duplicato collegato al logo 1",
  "Logo 2": "Logo 2",
  "Independent logo file, position and size": "File del logo indipendente, posizione e dimensione",
  "Table/room number": "Numero tavolo/camera",
  "Optional text element": "Elemento di testo facoltativo",
  "Branding circle": "Cerchio del marchio",
  "Colour and visibility": "Colore e visibilità",
  "Icon, circle colour and position": "Icona, colore del cerchio e posizione",
  "Payment providers": "Metodi di pagamento",
  "Multiple selection, colour and size": "Selezione multipla, colore e dimensione",
  "Social media & platforms": "Social media e piattaforme",
  "Reviews, social media and platforms": "Recensioni, social media e piattaforme",
  "Add": "Aggiungi",
  "Add more elements": "Aggiungi altri elementi",
  "Measurements & alignment": "Misure e allineamento",
  "Show measurements and set snapping guides": "Mostra misure e imposta le guide di aggancio",
  "Uploads & Downloads": "Caricamenti e download",
  "Design and print files": "File di design e di stampa",
  "Templates": "Modelli",
  "Choose a language, then explore templates": "Scelga una lingua, poi esplori i modelli",
  "Choose by use case": "Scegli per caso d’uso",
  "Visibility, position, size and backing panel": "Visibilità, posizione, dimensione e pannello di sfondo",
  "Background": "Sfondo",
  "Stainless-steel surface is fixed": "La superficie in acciaio inox è fissa",
  "Colour, gradient and optional image": "Colore, sfumatura e immagine facoltativa",
  "Symbol, rotation, colour and size": "Simbolo, rotazione, colore e dimensione",
  "Position, colour and size": "Posizione, colore e dimensione",
  "Choose font": "Scegli carattere",
  "Choose colour": "Scegli colore",
  "as hex code": "come codice esadecimale",
  "Letter spacing": "Spaziatura caratteri",
  "Decrease letter spacing": "Riduci spaziatura caratteri",
  "Increase letter spacing": "Aumenta spaziatura caratteri",
  "Style": "Stile",
  "Font style": "Stile del carattere",
  "This upload contains only the Normal style.": "Questo caricamento contiene solo lo stile Normale.",
  " (not available for entire selection)": " (non disponibile per l’intera selezione)",
  "Symbol": "Simbolo",
  "Choose symbol": "Scegli simbolo",
  "Search": "Cerca",
  "e.g. Wi-Fi, food, arrow": "es. Wi-Fi, cibo, freccia",
  "Search pictograms": "Cerca pittogrammi",
  "Category": "Categoria",
  "No matching symbols. Try another search or category.": "Nessun simbolo corrispondente. Provi un’altra ricerca o categoria.",
  "Upload custom pictogram": "Carica pittogramma personalizzato",
  "SVG up to 600 KB · PNG up to 500 KB and 1,000 × 1,000 px.": "SVG fino a 600 KB · PNG fino a 500 KB e 1.000 × 1.000 px.",
  "All categories": "Tutte le categorie",
  "Please use a vector-only SVG for laser engraving.": "Per l’incisione laser utilizzi un SVG composto solo da vettori.",
  "All three additional pictogram slots are in use.": "Tutti e tre gli spazi per i pittogrammi aggiuntivi sono occupati.",
  "This symbol could not be applied.": "Impossibile applicare questo simbolo.",
  "Please choose an SVG up to 600 KB or PNG up to 500 KB.": "Scelga un SVG fino a 600 KB o un PNG fino a 500 KB.",
  "Checking file …": "Verifica del file …",
  "PNG dimensions must not exceed 1,000 × 1,000 pixels.": "Le dimensioni PNG non devono superare 1.000 × 1.000 pixel.",
  "This file could not be used as a pictogram.": "Impossibile utilizzare questo file come pittogramma.",
  "The file could not be read.": "Impossibile leggere il file.",
  "Add pictogram": "Aggiungi pittogramma",
  "Show more symbols": "Mostra altri simboli",
  "Size": "Dimensione",
  "Decrease": "Riduci",
  "Increase": "Aumenta",
  "Opacity": "Opacità",
  "Decrease opacity": "Riduci opacità",
  "Increase opacity": "Aumenta opacità",
  "SVG colour": "Colore SVG",
  "Single colour": "Monocromatico",
  "Original colours": "Colori originali",
  "Use original": "Usa originale",
  "Recolour": "Ricolora",
  "Colour": "Colore",
  "Rectangular": "Rettangolare",
  "Rounded corners": "Angoli arrotondati",
  "Round": "Rotondo",
  "Fill": "Riempimento",
  "On": "Attivata",
  "Shape": "Forma",
  "Background shape": "Forma dello sfondo",
  "Background colour": "Colore dello sfondo",
  "Padding": "Margine interno",
  "Adjust text shape": "Regola forma del testo",
  "Brand colours": "Colori del marchio",
  "Laser · Black": "Laser · Nero",
  "Use original colours": "Usa colori originali",
  "Text": "Testo",
  "Logo": "Logo",
  "Framed": "Con cornice",
  "Wordmark": "Logotipo",
  "Symbol and wordmark": "Simbolo e logotipo",
  "Framed logo": "Logo con cornice",
  "Original": "Originale",
  "Reviews": "Recensioni",
  "Social media": "Social media",
  "Platforms": "Piattaforme",
  "Reset position and size": "Reimposta posizione e dimensione",
  "Measurements and safety zones": "Misure e zone di sicurezza",
  "Horizontal snapping guides": "Guide di aggancio orizzontali",
  "Vertical snapping guides": "Guide di aggancio verticali",
  "Snapping guides align elements while dragging. Select an element and use the arrow keys for fine movement; hold Shift for larger steps.": "Le guide allineano gli elementi durante il trascinamento. Selezioni un elemento e utilizzi i tasti freccia per spostamenti precisi; tenga premuto Maiusc per spostamenti maggiori.",
  "Second logo": "Secondo logo",
  "Add an independent logo file": "Aggiungi un file di logo indipendente",
  "Show and edit saved provider logos": "Mostra e modifica i loghi dei metodi salvati",
  "Choose and style provider logos": "Scegli e personalizza i loghi dei metodi",
  "Reviews, networks and contact channels": "Recensioni, reti e canali di contatto",
  "Add text": "Aggiungi testo",
  "Up to three additional text areas": "Fino a tre aree di testo aggiuntive",
  "additional pictograms used": "pittogrammi aggiuntivi utilizzati",
  "No additional elements are currently available.": "Al momento non sono disponibili altri elementi.",
  "template": "modello",
  "templates": "modelli",
  "Choose the template language": "Scelga la lingua del modello",
  "Which language should your design use?": "Quale lingua desidera per il design?",
  "No template languages are currently available.": "Al momento non sono disponibili lingue per i modelli.",
  "Template language": "Lingua del modello",
  "Change language": "Cambia lingua",
  "Use template": "Usa modello",
  "No templates yet": "Nessun modello disponibile",
  "Customer templates coming soon": "Modelli personalizzati in arrivo",
  "Templates are being prepared": "Modelli in preparazione",
  "No matching templates are currently available for this language and selection.": "Al momento non sono disponibili modelli adatti per questa lingua e selezione.",
  "Your partner’s customer-specific templates will appear here.": "Qui appariranno i modelli personalizzati del Suo partner.",
  "The first SMOOF designs will appear here as soon as they are added.": "I primi design SMOOF appariranno qui non appena verranno aggiunti.",
  "Template category": "Categoria del modello",
  "Each logo is positioned independently. Original variants retain their brand colours.": "Ogni logo è posizionato indipendentemente. Le varianti originali mantengono i colori del marchio.",
  "Remove logo": "Rimuovi logo",
  "Open": "Apri",
  "Open file": "Apri file",
  "Design": "Design",
  "Save design": "Salva design",
  "Mockup": "Anteprima",
  "Save mockup": "Salva anteprima",
  "Approval": "Approvazione",
  "Save proof": "Salva prova di stampa",
  "Production": "Produzione",
  "Download file": "Scarica file",
  "Sign in to download": "Accedi per scaricare",
  "Check again": "Verifica di nuovo",
  "QR code visible": "Codice QR visibile",
  "Visible": "Visibile",
  "Hidden": "Nascosto",
  "QR code colour": "Colore del codice QR",
  "Backing panel": "Pannello di sfondo",
  "Backing panel visible": "Pannello di sfondo visibile",
  "Locked transparent for DOT ME": "Trasparenza fissa per DOT ME",
  "Hidden with QR code": "Nascosto insieme al codice QR",
  "Panel colour": "Colore del pannello",
  "Scanning guidance": "Indicazioni per la scansione",
  "Low contrast between the QR code and its background may affect scanning on some devices. For the best scan reliability, use high contrast, such as a black QR code on a white background.": "Un contrasto basso tra il codice QR e lo sfondo può compromettere la scansione su alcuni dispositivi. Per una scansione affidabile utilizzi un contrasto elevato, ad esempio un codice QR nero su sfondo bianco.",
  " Very small QR codes may be harder to scan depending on print quality and device.": " I codici QR molto piccoli possono essere più difficili da scansionare, a seconda della qualità di stampa e del dispositivo.",
  " Hiding the QR code also hides its panel. The panel can be hidden separately without hiding the QR code.": " Nascondendo il codice QR si nasconde anche il pannello. Il pannello può essere nascosto separatamente senza nascondere il codice QR.",
  " Laser engraving always outputs the QR code in black.": " Nell’incisione laser il codice QR viene sempre riprodotto in nero.",
  "This element’s settings are currently unavailable.": "Le impostazioni di questo elemento non sono attualmente disponibili.",
  "Font": "Carattere",
  "Pill outline": "Contorno a capsula",
  "Outline colour": "Colore del contorno",
  "Fill colour": "Colore del riempimento",
  "Coloured fill": "Riempimento colorato",
  "Coloured": "Colorato",
  "Transparent": "Trasparente",
  "Outline width": "Spessore del contorno",
  "Horizontal padding": "Margine orizzontale",
  "Vertical padding": "Margine verticale",
  "Reset": "Reimposta",
  "Remove text": "Rimuovi testo",
  "Appearance": "Aspetto",
  "Use single colour": "Usa un solo colore",
  "Mirroring": "Specchiatura",
  "Mirrored": "Specchiato",
  "Mirror horizontally": "Specchia orizzontalmente",
  "Remove pictogram": "Rimuovi pittogramma",
  "SVG required": "SVG richiesto",
  "Laser engraving only accepts vector logos in SVG format.": "L’incisione laser accetta solo loghi vettoriali in formato SVG.",
  "Colours inverted": "Colori invertiti",
  "Invert": "Inverti",
  "Crop": "Ritaglia",
  "Duplicate": "Duplica",
  "Edit duplicate": "Modifica duplicato",
  "Loading …": "Caricamento …",
  "Upload logo": "Carica logo",
  "Remove": "Rimuovi",
  "Upload": "Carica",
  "Remove duplicate": "Rimuovi duplicato",
  "Pictogram": "Pittogramma",
  "TAP/SCAN": "TAP/SCAN",
  "Arrow count": "Numero di frecce",
  "Fewer arrows": "Meno frecce",
  "More arrows": "Più frecce",
  "TAP/SCAN label visible": "Etichetta TAP/SCAN visibile",
  "Icon": "Icona",
  "Circle fill": "Riempimento del cerchio",
  "Coloured background": "Sfondo colorato",
  "Inside the QR code the NFC icon snaps exactly to the centre. Outside the QR protection zone it can be positioned freely.": "All’interno del codice QR l’icona NFC si aggancia esattamente al centro. Fuori dalla zona di protezione QR può essere posizionata liberamente.",
  "Providers": "Metodi",
  "Single-colour logos": "Loghi monocromatici",
  "Locked for DOT ME": "Bloccato per DOT ME",
  "The stainless-steel surface belongs to the product and cannot be recoloured or replaced by an image.": "La superficie in acciaio inox fa parte del prodotto e non può essere ricolorata o sostituita da un’immagine.",
  "No image selected": "Nessuna immagine selezionata",
  "Base colour": "Colore di base",
  "Gradient": "Sfumatura",
  "Start colour": "Colore iniziale",
  "End colour": "Colore finale",
  "Direction": "Direzione",
  "Image": "Immagine",
  "Replace image": "Sostituisci immagine",
  "Upload image": "Carica immagine",
  "The image fills the print area. Size and crop can be adjusted.": "L’immagine riempie l’area di stampa. Dimensione e ritaglio sono regolabili.",
  "Image size": "Dimensione dell’immagine",
  "Horizontal": "Orizzontale",
  "Vertical": "Verticale",
  "Reset image crop": "Reimposta ritaglio immagine",
  "Overlay": "Sovrapposizione",
  "Overlay colour": "Colore della sovrapposizione",
  "Overlay strength": "Intensità della sovrapposizione",
  "Reduce overlay": "Riduci sovrapposizione",
  "Increase overlay": "Aumenta sovrapposizione",
  "Remove background image": "Rimuovi immagine di sfondo",
  "Hide element": "Nascondi elemento",
  "Show element": "Mostra elemento",
  "Show more font styles": "Mostra altri stili di carattere",
  "Show more shapes": "Mostra altre forme",
  "Show more categories": "Mostra altre categorie",
  "Show more settings": "Mostra altre impostazioni",
  "More": "Altro",
  "Show more entries to the right": "Mostra altre voci a destra",
  "Show more content": "Mostra altri contenuti",
  "Back to layer": "Torna al livello",
  "Change visibility": "Cambia visibilità",
  "Layers": "Livelli",
  "Choose and edit an element": "Scelga e modifichi un elemento",
  "Editor help": "Aiuto dell’editor",
  "Features and print area": "Funzioni e area di stampa",
  "Choose layout or entire design": "Scelga il layout o l’intero design",
  "Print area guidance": "Indicazioni sull’area di stampa",
  "Introduction to the SMOOF DOTS Editor": "Introduzione all’editor SMOOF DOTS",
  "Explore the most important areas without changing your design.": "Esplori le aree principali senza modificare il design.",
  "Restart introduction": "Riavvia introduzione",
  "The font picker includes standard fonts and your previously uploaded fonts. Use “Upload custom font” to add several WOFF, WOFF2, TTF or OTF files together and confirm that you hold the required usage and production rights.": "La selezione dei caratteri include quelli standard e quelli già caricati. Con «Carica carattere personalizzato» può aggiungere più file WOFF, WOFF2, TTF o OTF insieme, confermando di possedere i diritti d’uso e di produzione necessari.",
  "Select your uploaded main logo and open the crop tool. For PNG, JPG and WEBP in colour printing, adjust the crop or remove transparent outer margins. Restore the full original at any time. Cropping is unavailable for SVG and laser engraving.": "Selezioni il logo principale caricato e apra lo strumento di ritaglio. Per PNG, JPG e WEBP nella stampa a colori, regoli il ritaglio o rimuova i margini esterni trasparenti. Può ripristinare l’originale completo in qualsiasi momento. Il ritaglio non è disponibile per SVG e incisione laser.",
  "Please select an SVG or PNG file.": "Selezioni un file SVG o PNG.",
  "The PNG file may not exceed 500 KB.": "Il file PNG non può superare 500 KB.",
  "The SVG file may not exceed 600 KB.": "Il file SVG non può superare 600 KB.",
  "Checking PNG …": "Verifica PNG …",
  "Checking SVG …": "Verifica SVG …",
  "The PNG may not exceed 1,000 × 1,000 pixels.": "Il PNG non può superare 1.000 × 1.000 pixel.",
  "Close hint": "Chiudi suggerimento",
  "Order & Pay": "Ordina e paga",
  "Menu": "Menu",
  "Guest directory": "Guida per gli ospiti",
  "Start faster with templates": "Inizi più rapidamente con i modelli",
  "Choose a prepared design and adapt it directly to your branding.": "Scelga un design già pronto e lo adatti al Suo marchio.",
  "Explore templates": "Esplora modelli",
  "Undo": "Annulla",
  "Redo": "Ripristina",
  "Reset design": "Reimposta design",
  "Help": "Aiuto",
  "Edit NFC symbol": "Modifica simbolo NFC",
  "Icon and circle": "Icona e cerchio",
  "Icon colour": "Colore dell’icona",
  "Circle colour": "Colore del cerchio",
  "Centred only inside the QR code. Freely positionable outside the QR protection zone.": "Centrato solo all’interno del codice QR. Posizionabile liberamente fuori dalla zona di protezione QR.",
  "Reset position": "Reimposta posizione",
  "Icon, circle and position": "Icona, cerchio e posizione",
  "Digital menu": "Menu digitale",
  "Digital guest directory": "Guida digitale per gli ospiti",
  "Wi-Fi": "Wi-Fi",
  "Time tracking": "Rilevazione presenze",
  "Signage": "Segnaletica",
  "": "",
  "A one-of-one\nis taking shape.": "Un pezzo unico\nprende forma.",
  "Your SMOOF DOT is being prepared from your personal design.": "Il Suo SMOOF DOT viene preparato a partire dal Suo design personale.",
  "Your idea becomes unmistakable": "La Sua idea diventa inconfondibile",
  "Your personal motif is captured as an individual design.": "Il Suo motivo personale viene acquisito come design individuale.",
  "Distinctly yours,\ndown to every detail.": "Unicamente Suo,\nin ogni dettaglio.",
  "Colors, shapes, and elements are coming together as your unique piece.": "Colori, forme ed elementi si uniscono nel Suo pezzo unico.",
  "Every detail finds its place": "Ogni dettaglio trova il suo posto",
  "Colors, shapes and elements unite as your one-of-one.": "Colori, forme ed elementi si uniscono nel Suo pezzo unico.",
  "Preparing for\nproduction.": "Preparazione per\nla produzione.",
  "Your high-resolution production files are being created.": "Creazione dei file di produzione ad alta risoluzione.",
  "Prepared for production": "Pronto per la produzione",
  "Your design is translated into high-resolution production files.": "Il Suo design viene convertito in file di produzione ad alta risoluzione.",
  "Almost with\nyou.": "Quasi\na destinazione.",
  "Your cart is being updated.": "Aggiornamento del carrello.",
  "Your one-of-one is almost secured": "Il Suo pezzo unico è quasi al sicuro",
  "One more moment — then you will find it in your cart.": "Ancora un momento e lo troverà nel carrello.",
  "Curved arrow down": "Freccia curva verso il basso",
  "Wavy arrow left": "Freccia ondulata a sinistra",
  "Half-circle arrow right": "Freccia a semicerchio a destra",
  "Lightning arrow right": "Freccia a fulmine a destra",
  "Zigzag arrow down right": "Freccia a zigzag in basso a destra",
  "Loop arrow right": "Freccia ad anello a destra",
  "Curved arrow down right": "Freccia curva in basso a destra",
  "Diagonal loop arrow down": "Freccia diagonale ad anello verso il basso",
  "Loop arrow down right": "Freccia ad anello in basso a destra",
  "Wavy arrow up": "Freccia ondulata verso l’alto",
  "Curved arrow up": "Freccia curva verso l’alto",
  "Loop arrow up – wide": "Freccia ad anello verso l’alto – larga",
  "Loop arrow up – steep": "Freccia ad anello verso l’alto – ripida",
  "Wavy arrow up – narrow": "Freccia ondulata verso l’alto – stretta",
  "Zigzag arrow up – narrow": "Freccia a zigzag verso l’alto – stretta",
  "Open brush ring": "Cerchio aperto a pennello",
  "Four corner marks": "Quattro segni angolari",
  "Nine dots": "Nove punti",
  "Smile": "Sorriso",
  "Exclamation mark": "Punto esclamativo",
  "Two horizontal strokes": "Due tratti orizzontali",
  "Hand-drawn heart": "Cuore disegnato a mano",
  "Three emphasis rays": "Tre raggi di enfasi",
  "Brush curve": "Curva a pennello",
  "Left angle": "Angolo sinistro",
  "Curved brush stroke": "Tratto curvo a pennello",
  "Sparkle": "Scintilla",
  "Starburst": "Stella a raggi",
  "Two diagonal strokes": "Due tratti diagonali",
  "Double brush curve": "Doppia curva a pennello",
  "Abstract accent with rays": "Accento astratto con raggi",
  "Jagged emphasis": "Enfasi dentellata",
  "Two down-right angles": "Due angoli in basso a destra",
  "Open highlight circle – fine": "Cerchio di evidenziazione aperto – fine",
  "Open highlight circle – bold": "Cerchio di evidenziazione aperto – spesso",
  "Three rays downward": "Tre raggi verso il basso",
  "Zigzag accent": "Accento a zigzag",
  "Loop accent": "Accento ad anello",
  "Double-loop accent": "Accento a doppio anello",
  "Upper curve accent": "Accento curvo superiore",
  "Lower curve accent": "Accento curvo inferiore",
  "Spiral": "Spirale",
  "Two emphasis strokes": "Due tratti di enfasi",
  "Three rays upward": "Tre raggi verso l’alto",
  "Zigzag flourish": "Decorazione a zigzag",
  "Zigzag underline": "Sottolineatura a zigzag",
  "Underline with circle": "Sottolineatura con cerchio",
  "Underline with double mark": "Sottolineatura con doppio segno",
  "Pulse underline": "Sottolineatura a impulso",
  "Double-loop underline": "Sottolineatura a doppio anello",
  "Triple-loop underline": "Sottolineatura a triplo anello",
  "Underline with starting loop": "Sottolineatura con anello iniziale",
  "Underline with centre loop": "Sottolineatura con anello centrale",
  "Straight tapered underline": "Sottolineatura dritta affusolata",
  "Gently curved underline": "Sottolineatura leggermente curva",
  "Double curved underline": "Sottolineatura a doppia curva",
  "Short-stroke underline": "Sottolineatura a tratti corti",
  "Single-swish underline": "Sottolineatura a tratto singolo",
  "Triple-swish underline": "Sottolineatura a triplo tratto",
  "Wide-swish underline": "Sottolineatura a tratto largo",
  "HELLO – handwritten": "HELLO – scritto a mano",
  "Hi – handwritten": "Hi – scritto a mano",
  "NEW! in a circle": "NEW! in un cerchio",
  "NEW! with upward angle": "NEW! con angolo verso l’alto",
  "Diagonal NEW! with angle": "NEW! diagonale con angolo",
  "NEW! with emphasis rays": "NEW! con raggi di enfasi",
  "NEW! – handwritten": "NEW! – scritto a mano",
  "WELCOME! – handwritten": "WELCOME! – scritto a mano",
  "Rating stars": "Stelle di valutazione",
  "SMOOF dot arrow": "Freccia SMOOF DOT",
  "Chevron inward": "Chevron verso l’interno",
  "Arrow inward": "Freccia verso l’interno",
  "Arrow down": "Freccia verso il basso",
  "Arrow up": "Freccia verso l’alto",
  "Curved arrow": "Freccia curva",
  "Hand arrow left – Scan": "Freccia a mano a sinistra – Scansiona",
  "Hand arrow right – Discover": "Freccia a mano a destra – Scopri",
  "Hand arrow left – Tap or Scan": "Freccia a mano a sinistra – Tocca o scansiona",
  "Fork left – Food": "Forchetta a sinistra – Cibo",
  "Knife right – Drinks": "Coltello a destra – Bevande",
  "Smartphone": "Smartphone",
  "Tap smartphone": "Tocca con lo smartphone",
  "Contactless": "Contactless",
  "Credit card": "Carta di credito",
  "Wallet": "Portafoglio",
  "Payment terminal": "Terminale di pagamento",
  "Scan QR code": "Scansiona codice QR",
  "Receipt": "Ricevuta",
  "Order / pickup": "Ordine / ritiro",
  "Serving cloche": "Cloche da portata",
  "Cutlery": "Posate",
  "Wine glass": "Calice da vino",
  "Cocktail glass": "Bicchiere da cocktail",
  "Champagne glass": "Calice da champagne",
  "Service bell": "Campanello di servizio",
  "Room / key": "Camera / chiave",
  "Underline – Swoosh": "Sottolineatura – Svolazzo",
  "Underline – Double": "Sottolineatura – Doppia",
  "Underline – Brush": "Sottolineatura – Pennello",
  "Underline – Wave": "Sottolineatura – Onda",
  "Underline – Sketch": "Sottolineatura – Schizzo",
  "Underline – Loop": "Sottolineatura – Anello",
  "Underline – Straight": "Sottolineatura – Dritta",
  "Underline – Straight thin": "Sottolineatura – Dritta sottile",
  "Underline – Hand line": "Sottolineatura – Linea a mano",
  "Underline – Calligraphy": "Sottolineatura – Calligrafia",
  "Underline – Brush taper": "Sottolineatura – Pennello affusolato",
  "Underline – Long fine calligraphy": "Sottolineatura – Calligrafia lunga e fine",
  "Underline – Long fine brush stroke": "Sottolineatura – Pennellata lunga e fine",
  "Arrows": "Frecce",
  "Hand-drawn underlines": "Sottolineature a mano",
  "Highlights": "Evidenziazioni",
  "Decorative elements": "Elementi decorativi",
  "Lettering": "Scritte",
  "Smartphone & QR": "Smartphone e QR",
  "Payment": "Pagamento",
  "Food & Drinks": "Cibo e bevande",
  "Hospitality": "Ospitalità",
  "Custom pictograms": "Pittogrammi personalizzati",
  "All": "Tutti",
  "The mockup could not be created": "Impossibile creare l’anteprima",
  "The product view could not be composed completely. No incomplete file was downloaded.": "Impossibile comporre la vista completa del prodotto. Non è stato scaricato alcun file incompleto.",
  "ZIP · Front and back": "ZIP · Fronte e retro",
  "Your design is preserved.": "Il Suo design viene conservato.",
  "Checking sign-in status …": "Verifica dell’accesso …",
  "Your sign-in status could not be checked. Please try again.": "Impossibile verificare lo stato di accesso. Riprovi.",
  "Signed in. Your design has been restored.": "Accesso effettuato. Il design è stato ripristinato.",
  "Your design has been restored. Sign in to download the production file.": "Il design è stato ripristinato. Acceda per scaricare il file di produzione.",
  "Keep your design with you": "Conservi il Suo design",
  "Download design file": "Scarica file del design",
  "Your design file is ready to download. Keep it and open it from Downloads after signing in.": "Il file del design è pronto per il download. Lo conservi e lo apra da Download dopo aver effettuato l’accesso.",
  "The design file could not be created. Please try again.": "Impossibile creare il file del design. Riprovi.",
  "Back to design": "Torna al design",
  "Saving your design before sign-in …": "Salvataggio del design prima dell’accesso …",
  "Your design could not be saved safely. You remain in the editor. Download your design file first, then try signing in again.": "Impossibile salvare il design in sicurezza. Rimarrà nell’editor. Scarichi prima il file del design, poi riprovi ad accedere.",
  "Restoring your design …": "Ripristino del design …",
  "Design restored. Checking sign-in status …": "Design ripristinato. Verifica dell’accesso …",
  "Your design could not be restored yet. Please try again. Any saved draft is retained.": "Non è stato ancora possibile ripristinare il design. Riprovi. L’eventuale bozza salvata viene conservata.",
  "Creating PDF files": "Creazione dei file PDF",
  "The proof and production template are being created and will then be attached to the cart.": "La prova di stampa e il modello di produzione sono in preparazione e verranno allegati al carrello.",
  "The production files could not be created": "Impossibile creare i file di produzione",
  "The product has not been added to the cart. Please close this message and try again.": "Il prodotto non è stato aggiunto al carrello. Chiuda questo messaggio e riprovi.",
  "Please sign in to download production files and check your sign-in status.": "Acceda per scaricare i file di produzione e verifichi lo stato di accesso.",
  "Processing …": "Elaborazione …",
  "Production template PDF": "PDF del modello di produzione",
  "What would you like to reset?": "Che cosa desidera reimpostare?",
  "Layout only": "Solo layout",
  "Reset positions and sizes": "Reimposta posizioni e dimensioni",
  "Entire design": "Intero design",
  "Also reset text, colors and logo": "Reimposta anche testi, colori e logo",
  "The entire design will be reset. Text, colors, fonts, visibility settings and the uploaded logo will be removed. Continue?": "L’intero design verrà reimpostato. Testi, colori, caratteri, impostazioni di visibilità e logo caricato verranno rimossi. Continuare?",
  "Reset editor": "Reimposta editor",
  "Design editor active": "Editor di design attivo",
  "All design settings are available directly in the preview.": "Tutte le impostazioni del design sono disponibili direttamente nell’anteprima.",
  "Open editor": "Apri editor",
  "as percentage": "in percentuale",
  "Laser engraving only accepts SVG logos made entirely from vector paths and shapes. PNG, JPG, WebP, PDF, embedded images and live text are not allowed.": "L’incisione laser accetta solo loghi SVG composti interamente da tracciati e forme vettoriali. PNG, JPG, WebP, PDF, immagini incorporate e testo non convertito in tracciati non sono ammessi.",
  "The raster logo was removed because laser engraving requires an SVG vector logo.": "Il logo raster è stato rimosso perché l’incisione laser richiede un logo vettoriale SVG.",
  "Show frontal product view": "Mostra vista frontale del prodotto",
  "Show 3D view": "Mostra vista 3D",
  "Arrow": "Freccia",
  "checking…": "verifica…",
  "unavailable": "non disponibile",
  "currently unavailable": "attualmente non disponibile",
  "TABLE 56": "TAVOLO 56",
  "Move or resize QR code": "Sposta o ridimensiona codice QR",
  "Another element currently occupies the QR protection zone. Show the QR code anyway? Please reposition overlapping content before production.": "Un altro elemento occupa la zona di protezione QR. Mostrare comunque il codice QR? Riposizioni i contenuti sovrapposti prima della produzione.",
  "Ø 90 mm wood base": "Base in legno Ø 90 mm",
  "symbol": "simbolo",
  "symbols": "simboli",
  "Upload custom font": "Carica carattere personalizzato",
  "Custom font": "Carattere personalizzato",
  "Regular": "Normale",
  "Bold": "Grassetto",
  "Extra bold": "Extra grassetto",
  "Italic": "Corsivo",
  "Extra light": "Extra leggero",
  "Light": "Leggero",
  "Medium": "Medio",
  "Semi bold": "Semigrassetto",
  "Select and compare instantly": "Selezioni e confronti subito",
  "Current": "Attuale",
  "Search Google Fonts": "Cerca in Google Fonts",
  "Recommended": "Consigliati",
  "Sans Serif": "Senza grazie",
  "Serif": "Con grazie",
  "Display": "Decorativi",
  "Handwriting": "Manoscritti",
  "Recent": "Recenti",
  "Curated selection – use search for more fonts": "Selezione consigliata – usi la ricerca per altri caratteri",
  "Searching the Easify font catalogue …": "Ricerca nel catalogo caratteri Easify …",
  "Results from Easify – refine your search for more": "Risultati da Easify – affini la ricerca per trovarne altri",
  "Results from Easify": "Risultati da Easify",
  "Enter at least two characters": "Inserisca almeno due caratteri",
  "No matching font found. Check the spelling or try another search.": "Nessun carattere corrispondente trovato. Verifichi l’ortografia o provi un’altra ricerca.",
  "No recently used fonts yet.": "Nessun carattere utilizzato di recente.",
  "Enter your own brand font": "Inserisca il carattere del Suo marchio",
  "Applying font …": "Applicazione del carattere …",
  "Font selected": "Carattere selezionato",
  "This font could not be selected in Easify.": "Impossibile selezionare questo carattere in Easify.",
  "applies to all three text lines": "si applica a tutte e tre le righe di testo",
  "German": "Tedesco",
  "English": "Inglese",
  "Italian": "Italiano",
  "German / English": "Tedesco / Inglese",
  "German / English bilingual": "Bilingue tedesco / inglese",
  "Laser engraving only accepts SVG logos made entirely from vector paths and shapes. PNG, JPG, WebP, PDF, embedded images and live text are not permitted.": "L’incisione laser accetta solo loghi SVG composti interamente da tracciati e forme vettoriali. PNG, JPG, WebP, PDF, immagini incorporate e testo non convertito in tracciati non sono ammessi.",
  "Font – applies to all text lines": "Carattere – si applica a tutte le righe di testo",
  "Font – all text lines": "Carattere – tutte le righe di testo"
};
  const legacyItalian = {
  "Bewertungssterne": "Stelle di valutazione",
  "Website": "Sito web",
  "Mail": "E-mail",
  "Vorderseite": "Fronte",
  "Rückseite": "Retro",
  "Vorne": "Fronte",
  "Hinten": "Retro",
  "Druckseite": "Lato di stampa",
  "Druckseite auswählen": "Scegli lato di stampa",
  "Vorne nach hinten kopieren": "Copia fronte sul retro",
  "Das Design der Vorderseite auf die Rückseite kopieren": "Copia il design del fronte sul retro",
  "Nach hinten kopiert ✓": "Copiato sul retro ✓",
  "Kopieren nicht möglich": "Impossibile copiare",
  "Die Seitenverwaltung ist noch beschäftigt. Bitte kurz warten.": "La gestione dei lati è ancora occupata. Attenda un momento.",
  "Ungültiger Seitenwechsel.": "Cambio lato non valido.",
  "Vorschau wird aktualisiert": "Aggiornamento dell’anteprima",
  "Bitte ein PNG-, JPG- oder WebP-Bild mit maximal 15 MB auswählen.": "Selezioni un’immagine PNG, JPG o WebP di massimo 15 MB.",
  "Hintergrund auswählen": "Scegli sfondo",
  "Logo auswählen und verschieben": "Seleziona e sposta logo",
  "Logo auswählen": "Seleziona logo",
  "Logo verkleinern": "Riduci logo",
  "Logo vergrößern": "Ingrandisci logo",
  "Hilfslinien und Bemaßung ausblenden": "Nascondi guide e misure",
  "Hilfslinien und Bemaßung anzeigen": "Mostra guide e misure",
  "Alle Positionen und Größen zurücksetzen": "Reimposta tutte le posizioni e dimensioni",
  "Hinweise zur Druckfläche": "Indicazioni sull’area di stampa",
  "Gestrichelte Außenlinie: Produktkante – wird nicht gedruckt.": "Linea esterna tratteggiata: bordo del prodotto – non viene stampata.",
  "Orange gestrichelte Fläche: QR-Schutzzone – andere Elemente können hier nicht platziert werden.": "Area tratteggiata arancione: zona di protezione QR – non è possibile posizionare altri elementi qui.",
  "Element antippen: Text zeigt Schriftschnitt und Farbe, Pfeile ihre gemeinsame Farbe. Ausgewählten Text erneut antippen, um direkt zu schreiben.": "Tocchi un elemento: il testo mostra stile e colore, le frecce il loro colore comune. Tocchi di nuovo il testo selezionato per scrivere direttamente.",
  "Bemaßung: ausgewählter Durchmesser der Druckfläche.": "Misura: diametro selezionato dell’area di stampa.",
  "Oberflächeneffekt ausblenden": "Nascondi effetto superficie",
  "Oberflächeneffekt anzeigen": "Mostra effetto superficie",
  "Text verkleinern": "Riduci testo",
  "Text vergrößern": "Ingrandisci testo",
  "Text zurücksetzen": "Reimposta testo",
  "Textzeile ausblenden": "Nascondi riga di testo",
  "Schriftart – gilt für alle Textzeilen": "Carattere – si applica a tutte le righe di testo",
  "Logo konnte nicht geladen werden": "Impossibile caricare il logo",
  "Logo wird hochgeladen": "Caricamento del logo",
  "Bitte wähle eine Datei in einem der erlaubten Formate: ": "Scelga un file in uno dei formati consentiti: ",
  "Bitte lade die Seite neu und versuche den Upload erneut.": "Ricarichi la pagina e riprovi a caricare il file.",
  "Bitte warte einen Moment. Anschließend kannst du das Logo bearbeiten.": "Attenda un momento. Poi potrà modificare il logo.",
  "Bitte öffne die Logo-Auswahl erneut.": "Riapra la selezione del logo.",
  "Das Uploadfeld ist noch beschäftigt. Bitte versuche es erneut.": "Il campo di caricamento è ancora occupato. Riprovi.",
  "Der Upload dauert länger als üblich. Bitte lasse diese Seite geöffnet.": "Il caricamento richiede più tempo del solito. Lasci aperta questa pagina.",
  "Bitte versuche den Upload erneut.": "Riprovi a caricare il file.",
  "Logo 1 Duplikat": "Duplicato del logo 1",
  "Farbe": "Colore",
  "Lasergravur · Schwarz-Weiß": "Incisione laser · Bianco e nero",
  "Farbdruck": "Stampa a colori",
  "Produktmaße": "Misure del prodotto",
  "Vorder-/Rückseitensteuerung ist noch nicht bereit.": "La gestione del fronte e del retro non è ancora pronta.",
  "Die erzeugte Mockup-Datei ist kein gültiges PNG.": "Il file di anteprima generato non è un PNG valido.",
  "Die gerenderte Designfläche konnte nicht gelesen werden.": "Impossibile leggere l’area del design renderizzata.",
  "Der Epoxy-GL-Effekt konnte nicht exportiert werden.": "Impossibile esportare l’effetto epossidico GL.",
  "Die hochauflösende BASE-Darstellung ist nicht verfügbar.": "La rappresentazione BASE ad alta risoluzione non è disponibile.",
  "Der hochauflösende Mockup-Canvas ist nicht verfügbar.": "L’area di disegno dell’anteprima ad alta risoluzione non è disponibile.",
  "Der Mockup-Ausgabe-Canvas ist nicht verfügbar.": "L’area di esportazione dell’anteprima non è disponibile.",
  "Der hochauflösende DOT-Canvas ist nicht verfügbar.": "L’area di disegno DOT ad alta risoluzione non è disponibile.",
  "Der DOT-Ausgabe-Canvas ist nicht verfügbar.": "L’area di esportazione DOT non è disponibile.",
  "Die 3D-Projektion ist ungültig.": "La proiezione 3D non è valida.",
  "Die 3D-Produktansicht ist nicht verfügbar.": "La vista 3D del prodotto non è disponibile.",
  "Der 3D-Design-Canvas ist nicht verfügbar.": "L’area del design 3D non è disponibile.",
  "Der hochauflösende 3D-Canvas ist nicht verfügbar.": "L’area 3D ad alta risoluzione non è disponibile.",
  "Der 3D-Ausgabe-Canvas ist nicht verfügbar.": "L’area di esportazione 3D non è disponibile.",
  "Das aktuelle Produktprofil wird nicht unterstützt.": "Il profilo del prodotto attuale non è supportato.",
  "Der Design-Renderer ist noch nicht bereit.": "Il renderer del design non è ancora pronto.",
  "Die vollständige Produktansicht ist noch nicht bereit.": "La vista completa del prodotto non è ancora pronta.",
  "Produktprofil und Mockup-Compositor stimmen nicht überein.": "Il profilo del prodotto e il compositore dell’anteprima non corrispondono.",
  "Schrift konnte nicht geladen werden: ": "Impossibile caricare il carattere: ",
  "Farbe der Pfeile": "Colore delle frecce",
  "Farbe von TAP und SCAN": "Colore di TAP e SCAN",
  "Pfeile und Beschriftung auswählen": "Seleziona frecce ed etichetta",
  "Piktogramm und Beschriftung auswählen": "Seleziona pittogramma ed etichetta",
  "Piktogramm auswählen": "Seleziona pittogramma",
  "Ausgewählte Textzeile verkleinern": "Riduci riga di testo selezionata",
  "Ausgewählte Textzeile vergrößern": "Ingrandisci riga di testo selezionata",
  "Ausgewählte Textzeile zurücksetzen": "Reimposta riga di testo selezionata",
  "Zweites Logo verkleinern": "Riduci secondo logo",
  "Zweites Logo vergrößern": "Ingrandisci secondo logo",
  "Endformat - nur Hilfslinie, wird nicht gedruckt": "Formato finale – solo guida, non viene stampata",
  "Bitte den Editor neu laden, um die Schriftschnitte zu prüfen.": "Ricarichi l’editor per verificare gli stili dei caratteri.",
  "Die Laser-Pfadbereinigung ist nicht geladen. Bitte die Seite neu laden und den Export erneut starten.": "La pulizia dei tracciati laser non è caricata. Ricarichi la pagina e riavvii l’esportazione.",
  "Für die Lasergravur dürfen Logos ausschließlich als echte SVG-Vektordateien hochgeladen werden.": "Per l’incisione laser i loghi devono essere caricati esclusivamente come veri file vettoriali SVG.",
  "Das SVG-Logo enthält eine externe oder eingebettete Rasterquelle.": "Il logo SVG contiene una sorgente raster esterna o incorporata.",
  "Das SVG-Logo muss vollständig aus Vektorpfaden und Vektorformen bestehen.": "Il logo SVG deve essere composto interamente da tracciati e forme vettoriali.",
  "Das SVG-Logo verweist auf eine externe Datei.": "Il logo SVG fa riferimento a un file esterno.",
  "Das SVG-Logo besitzt keine gültige viewBox.": "Il logo SVG non ha una viewBox valida.",
  "Laserexport enthält eine externe Dateireferenz.": "L’esportazione laser contiene un riferimento a un file esterno.",
  "Hintergrundbilder sind für die Lasergravur nicht zulässig. Bitte verwenden Sie ausschließlich Vektorobjekte.": "Le immagini di sfondo non sono ammesse per l’incisione laser. Utilizzi esclusivamente oggetti vettoriali.",
  "Verstanden": "Ho capito",
  "Hintergrundbild hochladen": "Carica immagine di sfondo",
  "Hintergrund": "Sfondo",
  "Hintergrundfarbe": "Colore dello sfondo",
  "Schriftschnitt": "Stile del carattere",
  "Textfarbe": "Colore del testo",
  "Textzeile einblenden": "Mostra riga di testo",
  "Textzeile wieder einblenden": "Mostra di nuovo riga di testo",
  "3D-Ansicht": "Vista 3D",
  "SMOOF · Eigener Text": "SMOOF · Testo personalizzato"
};
  const locale = () => {
    const language = String(document.documentElement.lang || window.Shopify?.locale || 'de').toLowerCase().split(/[-_]/)[0];
    return ['de', 'en', 'it'].includes(language) ? language : 'de';
  };
  const dynamic = [
    [/^Step (\d+) of (\d+)$/, (_, n, total) => `Passaggio ${n} di ${total}`],
    [/^View (RHL|QHL|RHS|QHS|RML) (.+) with domed DOT GL from all sides$/, (_, product, material) => `Visualizza ${product} ${material} da ogni lato, con DOT GL bombato`],
    [/^Fitted to (\d+)% to keep text and band clear\.$/, (_, n) => `Adattato al ${n}% per lasciare liberi testo e fascia.`],
    [/^“([\s\S]*)” was applied\.$/, (_, name) => `«${name}» è stato applicato.`],
    [/^Validating font (\d+) of (\d+) …$/, (_, n, total) => `Verifica del carattere ${n} di ${total} …`],
    [/^(\d+) added, (\d+) already available, (\d+) not loaded\. Select your font under “My fonts”\.$/, (_, a,b,c) => `${a} aggiunti, ${b} già disponibili, ${c} non caricati. Scelga il carattere in «I miei caratteri».`],
    [/^([\s\S]*): unsupported image data\.$/, (_, name) => `${name}: dati immagine non supportati.`],
    [/^([\s\S]*): image too large\.$/, (_, name) => `${name}: immagine troppo grande.`],
    [/^This file was created for another SMOOF product\. It will be adapted to this product and its technical requirements( and will apply compatible product settings)?\. The current design will be replaced\. Do you want to open the file\?$/, (_, settings) => `Questo file è stato creato per un altro prodotto SMOOF. Verrà adattato a questo prodotto e ai suoi requisiti tecnici${settings ? ' e applicherà le impostazioni del prodotto compatibili' : ''}. Il design attuale verrà sostituito. Desidera aprire il file?`],
    [/^The current design will be replaced( and the saved product settings will be applied)?\. Do you want to open this file\?$/, (_, settings) => `Il design attuale verrà sostituito${settings ? ' e verranno applicate le impostazioni del prodotto salvate' : ''}. Desidera aprire questo file?`],
    [/^Additional text (\d+)$/, (_, n) => `Testo aggiuntivo ${n}`],
    [/^Additional pictogram (\d+)$/, (_, n) => `Pittogramma aggiuntivo ${n}`],
    [/^The style “([\s\S]*)” could not be verified for “([\s\S]*)”\. Please select an available style or reload and try again\.$/, (_, style, font) => `Impossibile verificare lo stile «${style}» per «${font}». Selezioni uno stile disponibile oppure ricarichi e riprovi.`]
  ];
  const lookup = (en, fallback = en) => {
    if (Object.prototype.hasOwnProperty.call(italian, en)) return italian[en];
    for (const [pattern, format] of dynamic) { const match = String(en).match(pattern); if (match) return format(...match); }
    return fallback;
  };
  const copy = (de, en) => locale() === 'it' ? lookup(en) : locale() === 'en' ? en : de;
  const legacy = value => locale() === 'it' ? (legacyItalian[value] ?? value) : value;
  const object = (de, en) => locale() === 'it' ? Object.fromEntries(Object.entries(en).map(([key, value]) => [key, lookup(value)])) : locale() === 'en' ? en : de;
  const label = value => typeof value === 'object' && value ? (locale() === 'it' ? value.it || lookup(value.en || value.de, value.en || value.de) : value[locale()] || value.de || value.en || '') : value;
  const fontStyle = value => locale() === 'it' ? String(value).replace(/Extra light|Extra fett|Extra bold|Fett|Bold|Normal|Regular|Kursiv|Italic|Light|Leicht|Medium|Semibold|Semi bold/g, s => ({'Extra light':'Extra leggero','Extra fett':'Extra grassetto','Extra bold':'Extra grassetto',Fett:'Grassetto',Bold:'Grassetto',Normal:'Normale',Regular:'Normale',Kursiv:'Corsivo',Italic:'Corsivo',Light:'Leggero',Leicht:'Leggero',Medium:'Medio',Semibold:'Semigrassetto','Semi bold':'Semigrassetto'}[s])) : value;
  window.SmoofI18n = Object.freeze({ version: '2.0.0-437', locale, copy, legacy, object, label, fontStyle });
  document.documentElement.dataset.smoofEditorLocale = locale();
})();
